/**
 * 模型显示名称映射工具
 * 用于在 UI 层面隐藏真实的模型名称
 */

export type AIModel = 'gemini' | 'deepseek';

/**
 * 获取模型的显示名称
 * gemini -> 模型A
 * deepseek -> 模型B
 */
export function getModelDisplayName(model?: AIModel | string): string {
  if (model === 'gemini') {
    return '模型A';
  } else if (model === 'deepseek') {
    return '模型B';
  }
  return '模型A'; // 默认
}

/**
 * 获取模型的简短标识
 * gemini -> A
 * deepseek -> B
 */
export function getModelLabel(model?: AIModel | string): string {
  if (model === 'gemini') {
    return 'A';
  } else if (model === 'deepseek') {
    return 'B';
  }
  return 'A'; // 默认
}

/**
 * 从显示名称获取真实模型名称（用于内部逻辑）
 */
export function getModelFromDisplayName(displayName: string): AIModel {
  if (displayName === '模型A') {
    return 'gemini';
  } else if (displayName === '模型B') {
    return 'deepseek';
  }
  return 'gemini'; // 默认
}
